import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import resourceSubject from '../reactivity/resource-subject';

Component('tr-project-calendar-view-trigger', {
  ready() {
    $(() => {
      resourceSubject('user-guide').next('project_calendar_view_show', {});
    });
  },
  beforeCache() {
    this.remove();
  },
});
